import { AnalogModel, ComponentDesign } from '@paragon/contract-library';
import { AnalogModelSchema, ModelChildLoader, ReferenceLineSchema } from '@paragon/layout-models';
import { isExplicitCalculatedLine } from '@paragon/relative-geometry';

import {
  CustomFeaturePatternTrussDesignSchema,
  CustomProfileTrussDesignSchema,
} from '../schemas/CustomTrussDesignSchema';

// If a component design has no analog model, we still want the row in navigation panel to display so that the
//   "regenerate analog model" button is visible.  Since the analog model row in the navigation panel is basically
//   treated as a container, it's safe to return a default empty object.
function getAnalogModelOrEmptyContainer(componentDesign: ComponentDesign): AnalogModel | { id: string } {
  return componentDesign.analogModel ?? { id: 'nullAnalogModel' };
}

export function registerTrussDesignerSpecificComponentDesignDataLoaders(loaders: ModelChildLoader, searchTerm: string) {
  function getMemberReferenceLines(componentDesign: ComponentDesign) {
    if (!componentDesign.component.referenceLines) {
      return [];
    }

    return componentDesign.component.referenceLines
      .filter(isExplicitCalculatedLine)
      .filter((line) => line.name.toLowerCase().includes(searchTerm));
  }

  loaders.add(CustomProfileTrussDesignSchema, ReferenceLineSchema, getMemberReferenceLines);
  loaders.add(CustomFeaturePatternTrussDesignSchema, ReferenceLineSchema, getMemberReferenceLines);

  loaders.add(CustomProfileTrussDesignSchema, AnalogModelSchema, getAnalogModelOrEmptyContainer);
  loaders.add(CustomFeaturePatternTrussDesignSchema, AnalogModelSchema, getAnalogModelOrEmptyContainer);
}
